const VERSION = "10.4.1";
export {
  VERSION
};
